function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "logo-full",
  transform: "translate(-250.89 -253.605)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4198",
  "data-name": "Group 4198",
  transform: "translate(250.89 253.605)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5310",
  "data-name": "Path 5310",
  d: "M263.147,259.679l-6.074-6.074v6.183H250.89l6.074,6.074C261.641,265.56,262.845,264.356,263.147,259.679Z",
  transform: "translate(-250.89 -253.605)",
  fill: "#da291c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5311",
  "data-name": "Path 5311",
  d: "M281.908,259.679c.3,4.677,1.505,5.881,6.183,6.183l6.074-6.074h-6.183v-6.183Z",
  transform: "translate(-269.434 -253.605)",
  fill: "#da291c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5312",
  "data-name": "Path 5312",
  d: "M263.147,290.8c-.3-4.677-1.505-5.881-6.182-6.183L250.89,290.7h6.183v6.182Z",
  transform: "translate(-250.89 -272.149)",
  fill: "#da291c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5313",
  "data-name": "Path 5313",
  d: "M281.908,290.8l6.074,6.074V290.7h6.183l-6.074-6.074C283.413,284.924,282.21,286.127,281.908,290.8Z",
  transform: "translate(-269.434 -272.149)",
  fill: "#da291c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4199",
  "data-name": "Group 4199",
  transform: "translate(280.675 256.602)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5314",
  "data-name": "Path 5314",
  d: "M333.984,269.451l-6.182-8.192h-2.848V279.7h2.7V265.649l6.334,8.016,6.226-8V279.7h2.7V261.259h-2.851Z",
  transform: "translate(-324.954 -261.179)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5315",
  "data-name": "Path 5315",
  d: "M380.348,271.527a6.728,6.728,0,0,0-5.133,2.123,7.345,7.345,0,0,0-1.86,5.14,7.218,7.218,0,0,0,1.945,5.142,6.838,6.838,0,0,0,5.184,2.12,6.733,6.733,0,0,0,4.107-1.194,6.859,6.859,0,0,0,2.329-3.1l.179-.466H384.19l-.1.184a3.71,3.71,0,0,1-3.585,2.068,4.167,4.167,0,0,1-3.034-1.138,4.405,4.405,0,0,1-1.314-2.466h11.182v-1.147a7.345,7.345,0,0,0-1.862-5.143A6.736,6.736,0,0,0,380.348,271.527Zm-4.144,5.846a4.321,4.321,0,0,1,1.266-2.273,4.434,4.434,0,0,1,5.756,0,4.343,4.343,0,0,1,1.267,2.275Z",
  transform: "translate(-353.89 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5316",
  "data-name": "Path 5316",
  d: "M421.79,267.145a5.691,5.691,0,0,0-4.323-1.757,6.593,6.593,0,0,0-5.11,2.127,8.03,8.03,0,0,0,0,10.274,6.428,6.428,0,0,0,4.973,2.125,5.906,5.906,0,0,0,4.458-1.733V279.7h2.7V261.259h-2.7Zm-1.018,2.135a5.611,5.611,0,0,1,0,6.743,3.883,3.883,0,0,1-3.17,1.379,4.085,4.085,0,0,1-3.228-1.386,5.407,5.407,0,0,1,0-6.73A4.084,4.084,0,0,1,417.6,267.9,3.885,3.885,0,0,1,420.772,269.28Z",
  transform: "translate(-376.099 -261.178)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2807",
  "data-name": "Rectangle 2807",
  width: 2.699,
  height: 14.095,
  transform: "translate(51.187 4.426)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2808",
  "data-name": "Rectangle 2808",
  width: 2.858,
  height: 2.861,
  transform: "translate(51.108 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5317",
  "data-name": "Path 5317",
  d: "M475.136,273.284a5.692,5.692,0,0,0-4.323-1.757,6.594,6.594,0,0,0-5.11,2.127,8.03,8.03,0,0,0,0,10.274,6.431,6.431,0,0,0,4.973,2.125,5.906,5.906,0,0,0,4.458-1.733v1.519h2.7v-14.1h-2.7Zm-1.018,2.135a5.613,5.613,0,0,1,0,6.744,3.883,3.883,0,0,1-3.17,1.379,4.085,4.085,0,0,1-3.228-1.386,5.408,5.408,0,0,1,0-6.73,4.086,4.086,0,0,1,3.229-1.387A3.886,3.886,0,0,1,474.118,275.419Z",
  transform: "translate(-407.991 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5318",
  "data-name": "Path 5318",
  d: "M512.682,278.245a11.5,11.5,0,0,0-2.226-.664c-.761-.147-1.478-.312-2.134-.49a5.689,5.689,0,0,1-1.556-.642,1.01,1.01,0,0,1-.5-.93c0-.392,0-1.588,2.754-1.588,1.88,0,2.87.586,3.024,1.791l.039.3h2.726l-.044-.382a4.216,4.216,0,0,0-1.49-2.853,6.264,6.264,0,0,0-4.106-1.26,6.8,6.8,0,0,0-4.138,1.076,3.688,3.688,0,0,0-1.463,3.1,3.04,3.04,0,0,0,.75,2.165,4.988,4.988,0,0,0,1.771,1.182,12.153,12.153,0,0,0,2.221.649c.793.156,1.49.32,2.131.5a5.476,5.476,0,0,1,1.552.679,1.1,1.1,0,0,1,.5.989,1.439,1.439,0,0,1-1.065,1.422,4.965,4.965,0,0,1-1.077.275,5.84,5.84,0,0,1-2.5-.12,2.453,2.453,0,0,1-1.859-2.2l-.031-.309H503.2l.021.363a4.457,4.457,0,0,0,1.677,3.326,6.744,6.744,0,0,0,4.486,1.421,7.224,7.224,0,0,0,4.193-1.094,3.764,3.764,0,0,0,1.622-3.271,3.185,3.185,0,0,0-.746-2.214A4.925,4.925,0,0,0,512.682,278.245Z",
  transform: "translate(-431.52 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5319",
  "data-name": "Path 5319",
  d: "M536.49,279.7h2.7V268.061h3.843V265.6h-3.843v-4.345h-2.7Z",
  transform: "translate(-451.422 -261.179)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5320",
  "data-name": "Path 5320",
  d: "M563.186,273.284a5.691,5.691,0,0,0-4.322-1.757,6.594,6.594,0,0,0-5.11,2.127,8.03,8.03,0,0,0,0,10.274,6.431,6.431,0,0,0,4.973,2.125,5.906,5.906,0,0,0,4.458-1.733v1.519h2.7v-14.1h-2.7Zm-1.018,2.135a5.611,5.611,0,0,1,0,6.743A3.883,3.883,0,0,1,559,283.541a4.085,4.085,0,0,1-3.228-1.386,5.407,5.407,0,0,1,0-6.73A4.085,4.085,0,0,1,559,274.038,3.884,3.884,0,0,1,562.168,275.419Z",
  transform: "translate(-460.633 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5321",
  "data-name": "Path 5321",
  d: "M600.925,271.527a5.231,5.231,0,0,0-2.289.462,5.509,5.509,0,0,0-2.3,1.885v-2.131h-2.7v14.1h2.7v-6.245a5.982,5.982,0,0,1,1.215-3.755,3.936,3.936,0,0,1,3.27-1.613h.586v-2.7Z",
  transform: "translate(-485.586 -267.317)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4697",
  "data-name": "Group 4697"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4201",
  "data-name": "Group 4201",
  transform: "translate(397.916 254.724)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4200",
  "data-name": "Group 4200"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5322",
  "data-name": "Path 5322",
  d: "M618.807,256.388a2.291,2.291,0,0,1,1.648.648,2.24,2.24,0,0,1,0,3.188,2.291,2.291,0,0,1-1.648.649,2.227,2.227,0,0,1-1.639-.658,2.113,2.113,0,0,1-.676-1.585,2.141,2.141,0,0,1,.676-1.594A2.26,2.26,0,0,1,618.807,256.388Zm0,4a1.772,1.772,0,0,0,1.279-.5,1.782,1.782,0,0,0,0-2.5,1.873,1.873,0,0,0-2.557,0,1.782,1.782,0,0,0,0,2.5A1.771,1.771,0,0,0,618.807,260.386Zm.964-.927a.63.63,0,0,0,.1.306H619.3a.655.655,0,0,1-.081-.306l-.018-.243a.358.358,0,0,0-.072-.234.3.3,0,0,0-.216-.063h-.459v.847h-.549v-2.306h1.063a.972.972,0,0,1,.612.176.587.587,0,0,1,.224.491.55.55,0,0,1-.333.531.506.506,0,0,1,.279.477Zm-1.315-.991h.477c.2,0,.3-.09.3-.27s-.1-.279-.315-.279h-.459Z",
  transform: "translate(-616.492 -256.388)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4696",
  "data-name": "Group 4696",
  transform: "translate(280.675 256.602)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5314-2",
  "data-name": "Path 5314",
  d: "M333.984,269.451l-6.182-8.192h-2.848V279.7h2.7V265.649l6.334,8.016,6.226-8V279.7h2.7V261.259h-2.851Z",
  transform: "translate(-324.954 -261.179)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5315-2",
  "data-name": "Path 5315",
  d: "M380.348,271.527a6.728,6.728,0,0,0-5.133,2.123,7.345,7.345,0,0,0-1.86,5.14,7.218,7.218,0,0,0,1.945,5.142,6.838,6.838,0,0,0,5.184,2.12,6.733,6.733,0,0,0,4.107-1.194,6.859,6.859,0,0,0,2.329-3.1l.179-.466H384.19l-.1.184a3.71,3.71,0,0,1-3.585,2.068,4.167,4.167,0,0,1-3.034-1.138,4.405,4.405,0,0,1-1.314-2.466h11.182v-1.147a7.345,7.345,0,0,0-1.862-5.143A6.736,6.736,0,0,0,380.348,271.527Zm-4.144,5.846a4.321,4.321,0,0,1,1.266-2.273,4.434,4.434,0,0,1,5.756,0,4.343,4.343,0,0,1,1.267,2.275Z",
  transform: "translate(-353.89 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5316-2",
  "data-name": "Path 5316",
  d: "M421.79,267.145a5.691,5.691,0,0,0-4.323-1.757,6.593,6.593,0,0,0-5.11,2.127,8.03,8.03,0,0,0,0,10.274,6.428,6.428,0,0,0,4.973,2.125,5.906,5.906,0,0,0,4.458-1.733V279.7h2.7V261.259h-2.7Zm-1.018,2.135a5.611,5.611,0,0,1,0,6.743,3.883,3.883,0,0,1-3.17,1.379,4.085,4.085,0,0,1-3.228-1.386,5.407,5.407,0,0,1,0-6.73A4.084,4.084,0,0,1,417.6,267.9,3.885,3.885,0,0,1,420.772,269.28Z",
  transform: "translate(-376.099 -261.178)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2807-2",
  "data-name": "Rectangle 2807",
  width: 2.699,
  height: 14.095,
  transform: "translate(51.187 4.426)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2808-2",
  "data-name": "Rectangle 2808",
  width: 2.858,
  height: 2.861,
  transform: "translate(51.108 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5317-2",
  "data-name": "Path 5317",
  d: "M475.136,273.284a5.692,5.692,0,0,0-4.323-1.757,6.594,6.594,0,0,0-5.11,2.127,8.03,8.03,0,0,0,0,10.274,6.431,6.431,0,0,0,4.973,2.125,5.906,5.906,0,0,0,4.458-1.733v1.519h2.7v-14.1h-2.7Zm-1.018,2.135a5.613,5.613,0,0,1,0,6.744,3.883,3.883,0,0,1-3.17,1.379,4.085,4.085,0,0,1-3.228-1.386,5.408,5.408,0,0,1,0-6.73,4.086,4.086,0,0,1,3.229-1.387A3.886,3.886,0,0,1,474.118,275.419Z",
  transform: "translate(-407.991 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5318-2",
  "data-name": "Path 5318",
  d: "M512.682,278.245a11.5,11.5,0,0,0-2.226-.664c-.761-.147-1.478-.312-2.134-.49a5.689,5.689,0,0,1-1.556-.642,1.01,1.01,0,0,1-.5-.93c0-.392,0-1.588,2.754-1.588,1.88,0,2.87.586,3.024,1.791l.039.3h2.726l-.044-.382a4.216,4.216,0,0,0-1.49-2.853,6.264,6.264,0,0,0-4.106-1.26,6.8,6.8,0,0,0-4.138,1.076,3.688,3.688,0,0,0-1.463,3.1,3.04,3.04,0,0,0,.75,2.165,4.988,4.988,0,0,0,1.771,1.182,12.153,12.153,0,0,0,2.221.649c.793.156,1.49.32,2.131.5a5.476,5.476,0,0,1,1.552.679,1.1,1.1,0,0,1,.5.989,1.439,1.439,0,0,1-1.065,1.422,4.965,4.965,0,0,1-1.077.275,5.84,5.84,0,0,1-2.5-.12,2.453,2.453,0,0,1-1.859-2.2l-.031-.309H503.2l.021.363a4.457,4.457,0,0,0,1.677,3.326,6.744,6.744,0,0,0,4.486,1.421,7.224,7.224,0,0,0,4.193-1.094,3.764,3.764,0,0,0,1.622-3.271,3.185,3.185,0,0,0-.746-2.214A4.925,4.925,0,0,0,512.682,278.245Z",
  transform: "translate(-431.52 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5319-2",
  "data-name": "Path 5319",
  d: "M536.49,279.7h2.7V268.061h3.843V265.6h-3.843v-4.345h-2.7Z",
  transform: "translate(-451.422 -261.179)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5320-2",
  "data-name": "Path 5320",
  d: "M563.186,273.284a5.691,5.691,0,0,0-4.322-1.757,6.594,6.594,0,0,0-5.11,2.127,8.03,8.03,0,0,0,0,10.274,6.431,6.431,0,0,0,4.973,2.125,5.906,5.906,0,0,0,4.458-1.733v1.519h2.7v-14.1h-2.7Zm-1.018,2.135a5.611,5.611,0,0,1,0,6.743A3.883,3.883,0,0,1,559,283.541a4.085,4.085,0,0,1-3.228-1.386,5.407,5.407,0,0,1,0-6.73A4.085,4.085,0,0,1,559,274.038,3.884,3.884,0,0,1,562.168,275.419Z",
  transform: "translate(-460.633 -267.317)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5321-2",
  "data-name": "Path 5321",
  d: "M600.925,271.527a5.231,5.231,0,0,0-2.289.462,5.509,5.509,0,0,0-2.3,1.885v-2.131h-2.7v14.1h2.7v-6.245a5.982,5.982,0,0,1,1.215-3.755,3.936,3.936,0,0,1,3.27-1.613h.586v-2.7Z",
  transform: "translate(-485.586 -267.317)",
  fill: "#fff"
}))));

function SvgLogoFullDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.655,
    height: 24.73,
    viewBox: "0 0 151.655 24.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullDark);
export default __webpack_public_path__ + "static/media/logo-full-dark.5b8c552e.svg";
export { ForwardRef as ReactComponent };